import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import DialogModal from "components/UI/DialogModals";
import { lang } from "i18nLang";
import { useEffect, useState } from "react";
import { ContractAttachmentStore } from "store";
import AttachmentsContract from "./AttachmentsContract";

const useStyles = makeStyles({
  loading: { cursor: "wait" },
});

const ModalAttachmentsContract = ({ open, onClose }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      ContractAttachmentStore.getContractAttachments();
    }
  }, [open]);

  const handleClose = () => {
    ContractAttachmentStore.removeAllUnsavedContractAttachment();
    onClose();
  };

  const handleConfirm = async () => {
    setLoading(true);
    ContractAttachmentStore.saveContractAttachments()
      .then(() => onClose())
      .finally(() => setLoading(false));

    // para não fechar o modal
    return true;
  };

  return (
    <DialogModal
      open={open}
      onClose={handleClose}
      className={clsx({ [classes.loading]: loading })}
      title={lang("attachments.attachFiles")}
      confirmLabel={lang("save")}
      onConfirm={handleConfirm}
      disabledConfirm={ContractAttachmentStore.hasFileBeingUploaded()}
    >
      <AttachmentsContract isEditing={true} isModal={true} />
    </DialogModal>
  );
};

export default ModalAttachmentsContract;
